import axios from '../axios';
import { LeadListsApi, GeosearchApi, ReverseAddressApi, PropertiesApi, LeadsApi, UpdateContactsApi, CombineListOfLeadsApi, UserApi } from './client/index';

export const propertiesApi = new PropertiesApi(undefined, '/api', axios);
export const leadListsApi = new LeadListsApi(undefined, '/api', axios);
export const geosearchApi = new GeosearchApi(undefined, '/api', axios);
export const addressSearchApi = new ReverseAddressApi(undefined, '/api', axios);
export const leadsApi = new LeadsApi(undefined, '/api', axios);
export const updateContactsApi = new UpdateContactsApi(undefined, '/api', axios);
export const combineListOfLeadsApi = new CombineListOfLeadsApi(undefined, '/api', axios);
export const userApi = new UserApi(undefined, '/api', axios);

// Export types
export type { QuotaApp, Quota, Limit, ApplicationType } from './client/index';
